import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/homepage-business/heroBackground-dark.png?url';

export default {
  lqip: `data:image/png;base64,UklGRpAAAABXRUJQVlA4WAoAAAAQAAAAHwAAEwAAQUxQSAoAAAABB9D9iAhERP8DVlA4IGAAAADwBACdASogABQAPm0uk0YkIqGhKA1QgA2JYwDM0Htv3wEJRPMiVEGm2LApj4oMj4AA/v/Ygn4Ky6t6hqJhFXLIoWVpqaRaiU4LqkIU1OO735ikjkGZOjEL7MzwtfZoAAA=`,
  src,
  width: 4320,
  height: 2742,
};
			